import { Chip } from "@mui/material";

// Maps a backend numeric enum value to a coloured MUI Chip, using the `<Name>Choices` / `<Name>ColorMap`
// triad from utils/choices.js. Falls back to the raw value when the enum grows a member the FE has not
// mapped yet, so an unknown status is visible rather than blank.
const StatusChip = ({ status, choices, colorMap, size = "small" }) => {
  if (status == null) return null;
  const choice = choices.find(c => c.id === status);
  return (
    <Chip
      label={choice?.name ?? status}
      color={colorMap?.[status] ?? "default"}
      size={size}
    />
  );
};

export default StatusChip;
